import React from "react";
import { Loader } from "../Common/Loader/Loader";
import { useUserStore } from "@/store/user";

type LoginVerificationLoaderProps = {
  message?: string;
  subMessage?: string;
};

export const LoginVerificationLoader: React.FC<LoginVerificationLoaderProps> = ({
  message = "Verifying...",
  subMessage = "Wait a moment, we're taking you back to your destination"
}) => {
  const theme = useUserStore((state) => state.theme);
  const loaderColor = theme === "dark" ? "#ffffff" : "#000000";

  return (
    <div className="bg-gray-50 dark:bg-gray-900 flex min-h-screen flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-6">
        <Loader className="w-[60px]" color={loaderColor} />
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-gray-900 text-xl font-semibold dark:text-foreground">{message}</h2>
          <p className="text-gray-600 dark:text-gray-400 text-sm">{subMessage}</p>
        </div>
      </div>
    </div>
  );
};
